// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_if-0";
export var headerCellHover = "_if-1";
export var readCellContainer = "_if-2";
export var searchHighlight = "_if-4";
export var unreadIndicator = "_if-3";